export default __webpack_public_path__ + "8cad3ac579452d7e1f5ea4e30c6ed2d8.png";